export enum TaskTypeEnum {
  TIMESHEET = "Mapa de Horas",
  TRIPSHEET = "Mapa de KM",
  VACATION_PLAN = "Pedido de Férias",
  EXPENSE = "Despesa",
}
